export default __webpack_public_path__ + "static/media/em_tshirt_2.6b4b4cb6.webp";